// extracted by mini-css-extract-plugin
module.exports = {"phantomFull":"CategoryList-module--phantom-full--1ixDZ","categoryList":"CategoryList-module--categoryList--35ZPY"};